module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.props) ? _c('div', {
    staticClass: "navigation-desktop",
    class: _vm.classObject
  }, [_c('div', {
    staticClass: "navigation-desktop__container"
  }, [_c('router-link', {
    staticClass: "navigation-desktop__logo",
    class: {
      "navigation-desktop__logo--active": _vm.active
    },
    attrs: {
      "to": "/"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.menuSelect($event)
      }
    }
  }, [_c('Icon', {
    attrs: {
      "name": "blacker_logo"
    }
  })], 1), _c('div', {
    staticClass: "navigation-desktop__buttons",
    class: {
      active: _vm.active
    }
  }, [_c('a', {
    staticClass: "navigation-desktop__button navigation-desktop__button--phone",
    attrs: {
      "href": "tel:" + _vm.props.acf.phone_url,
      "aria-label": "call us at 4 8 0, 8 3 9, 6 2 6 2"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.phone_text)
    }
  }), _c('div', {
    staticClass: "navigation-desktop__menu",
    class: {
      active: _vm.active
    },
    on: {
      "click": _vm.menuChange
    }
  }, [_c('div', {
    staticClass: "navigation-desktop__menu--text",
    class: {
      active: _vm.active
    }
  }, [_vm._v(_vm._s(_vm.menu))]), _c('span'), _c('span')])])], 1), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.active === true),
      expression: "active === true"
    }],
    staticClass: "navigation-desktop__overlay",
    on: {
      "click": _vm.menuChange
    }
  }, [_c('div', {
    staticClass: "navigation-desktop__links"
  }, _vm._l((_vm.links), function(link) {
    return (link.navigation) ? _c('div', {
      staticClass: "navigation-desktop__link"
    }, [_c('router-link', {
      attrs: {
        "to": link.path
      },
      on: {
        "click": _vm.menuSelect
      }
    }, [_vm._v(_vm._s(link.name))])], 1) : _vm._e()
  }), 0), _c('div', {
    staticClass: "navigation-desktop__phone-numbers"
  }, _vm._l((_vm.props.acf.locations), function(place) {
    return _c('div', {
      staticClass: "navigation-desktop__phone"
    }, [_c('div', {
      staticClass: "navigation-desktop__place"
    }, [_vm._v(_vm._s(place.location) + ":")]), _c('div', {
      staticClass: "navigation-desktop__number"
    }, [_vm._v(_vm._s(place.phone))])])
  }), 0), _c('div', {
    staticClass: "navigation-desktop__social"
  }, _vm._l((_vm.props.acf.social_media), function(soc) {
    return _c('div', {
      staticClass: "navigation-desktop__social-icon"
    }, [_c('a', {
      attrs: {
        "href": soc.link
      }
    }, [_c('Icon', {
      attrs: {
        "name": soc.icon
      }
    })], 1)])
  }), 0)])])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-171fcb28","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/navigation/navigation-desktop/navigation-desktop.pug
// module id = 629
// module chunks = 1